query BaseballTeamByTeamId (
  $teamId: UUID!
){
  team: baseballTeamByTeamId(teamId: $teamId) {
    squad
    teamId
    playerMappedForProjections: baseballTeamPlayerProjectionsMappedsByTeamId {
      nodes {
        playerId
      }
    }
  }
}
